import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-100 py-8 px-4 md:px-8 mt-12" data-id="element-174">
      <div className="max-w-5xl mx-auto text-center" data-id="element-175">
        <p className="text-sm text-gray-600 mb-2" data-id="element-176">
          © 2023 Wszystkie prawa zastrzeżone
        </p>
        <div className="flex justify-center space-x-4 text-xs text-gray-500" data-id="element-177">
          <a href="#" className="hover:underline" data-id="element-178">
            Polityka prywatności
          </a>
          <a href="#" className="hover:underline" data-id="element-179">
            Regulamin
          </a>
          <a href="#" className="hover:underline" data-id="element-180">
            Kontakt
          </a>
        </div>
        <p className="text-xs text-gray-500 mt-4" data-id="element-181">
          Wyniki mogą się różnić w zależności od indywidualnych okoliczności.
          Przedstawione historie są autentycznymi doświadczeniami naszych
          czytelniczek.
        </p>
      </div>
    </footer>;
};